







































import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import SvgImage from '~/components/General/SvgImage.vue';
import { APP_ROUTER_PATHS } from '~/constants';

interface Breadcrumbs {
  text: string,
  link: string,
}

export default defineComponent({
  name: 'Breadcrumbs',
  components: { SvgImage },
  props: {
    showHomePage: {
      type: Boolean,
      default: false,
    },
    showMainCategory: {
      type: Boolean,
      default: false,
    },
    items: {
      type: [Array, null] as PropType<Breadcrumbs[] | null>,
      default: () => ([]),
    },
  },

  setup(props) {
    const mainCategory = computed(() => (props.showMainCategory ? props.items?.[0]?.text : null));

    return {
      mainCategory,
    };
  },

  data() {
    return {
      routes: APP_ROUTER_PATHS,
    };
  },
});

